var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-radio-group',{attrs:{"value":_vm.currentValue,"label":_vm.name},on:{"change":_vm.onInput}},_vm._l((_vm.list),function(item){return _c('v-radio',{key:item,attrs:{"label":("" + item),"value":("" + item)}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47d64a1b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/apps/bpm/components/form/FormRadioButton.vue
// module id = null
// module chunks = 